@if ((facetList$ | async)?.facets; as facets) {
}

<div class="float-left w-100 filters-sidebar">
  @if ((facetList$ | async)?.facets; as facets) {
    <div
      [cxFocus]="isDialog ? dialogFocusConfig : {}"
      (esc)="close($event)"
      (click)="block($event)"
      >
      <div class="product-cate-options float-left col-lg-12 pl-0 pr-0">
        <div class="col-lg-12 p-0 float-left filter-by mt-1">
          @for (facet of facets; track facet) {
            <kn-br-facet
              #facetRef
              [facet]="facet"
              [cxFocus]="{ lock: true, trap: true, autofocus: 'a' }"
              (unlock)="expandFacetGroup(facet, facetRef)"
              [class.expanded]="true"
            ></kn-br-facet>
          }
        </div>
      </div>
    </div>
  }
</div>
